<template>

  <div class="table-col">

    <div class="input_block">
      <multiselect
        v-model="cityValue"

        :options="citySelectorOptions"
        :clear-on-select="false"
        :preserve-search="true"
        :show-labels="false"
        :disabled="isWorker()"

        @select="appendCityValue"

        label="value"
        placeholder="Выбрать"
        track-by="value"
        required
      >
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">{{ props.option.value }}</span>
          </div>
        </template>
      </multiselect>
    </div>

  </div>

</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from 'vue-multiselect'

export default {
  name: "cityColumn",

  components: {
    Multiselect,
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      cityValue: {
        value: this.data.city,
      }
    }
  },

  watch: {
    data (val) {
      this.cityValue = {
        value: val.city,
      }
    }
  },

  computed: {
    ...mapGetters([
      'meRoles',
      'citySelectorOptions',
    ])
  },

  methods: {
    isWorker() {
      if (this.data.disabled) {
        return true;
      } else {
        return !this.isAvailable(['admin', 'moderator']);
      }

    },

    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    },

    appendCityValue (selectOption) {
      this.data.city = selectOption.value;
    }
  },

}
</script>

<style scoped>
.table-col {
  min-width: 200px;
}
</style>
